module.exports = __webpack_public_path__ + "img/input-token.4a64b1bb.svg";